const basic = {
  namespaced: true,
  state: {
    pageTitle: "",
    platform: "pc",
    userInfo: {
      dwmc: "",
      linkName: "",
      zhiwu: "",
    },
  },
  getters: {
    pageTitle: (state) => state.pageTitle,
    platform: (state) => state.platform,
    userInfo: (state) => state.userInfo,
  },
  mutations: {
    updatePageTitle(state, pageTitle) {
      state.pageTitle = pageTitle;
    },
    updatePlatform(state, data) {
      state.platform = data;
    },
    updateUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
  },
  actions: {},
};
export default basic;
